<template>
  <div>
    <div :class="selectClass"  class="form-group">
      <label class="form-control__label name" :for="id">{{ labelText }}</label>

      <div class="custom-dropdown--wrapper">
        <select
          v-model="internalModel"
          v-bind="getFieldProperties"
          @blur="selectOnBlur"
          @focus="selectOnFocus"
          @change="updateValue($event.target.value)"
          @keydown.enter="selectUsingEnterKey"
          ref="select"
        >
          <template v-if="options">
            <option v-if="allowEmpty" value></option>
            <option v-for="(item, index) in options" :value="index" :key="index">
              {{ item }}
            </option>
          </template>
          <slot v-else></slot>
        </select>

        <div class="custom-dropdown--overlay" @click.prevent="openDropdown"></div>
        <div class="custom-dropdown--values" v-if="expanded">
          <div class="inner">
            <a href="#" 
              tabindex="-1"
              v-for="(item, index) in options" 
              :key="index"
              @click.prevent="setValueAndClose(index)"
              :class="[
                index===internalModel ? 'focus' : null
              ]"
            >{{ item }}</a>
          </div>
        </div>
        <div class="custom-dropdown--outer-overlay" v-if="expanded" @click.prevent="expanded=false"></div>
      </div>
      
      <!-- <icon class="form-select__arrow" symbol="form-select-arrow" /> -->
    </div>
    <p v-if="helpText" v-html="helpText" class="h5 mt--2x"></p>
    <form-errors :errors="errors" />
  </div>
</template>

<script>
// import FormControlMixin from '@/js/mixins/FormControlMixin';
import FormControlMixin from '../../mixins/FormControlMixin';
import bus from '../../utilities/eventbus';

export default {
  mixins: [FormControlMixin],
  props: {
    options: { type: Object, required: false },
    allowEmpty: { type: Boolean, default: true },
    staticOptions: { type: Boolean, required: false, default: false }
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data: function () {
    return {
      expanded: false
    }
  },
  watch: {
    options: function (val) {
      if(!this.staticOptions){
        // Reset internal model if options change dynamically
        this.internalModel = undefined;
      }
    },
  },
  computed: {
    selectClass() {
      return {
        'form-control': true,
        'form-control--has-value': this.internalModel !== '',
        'form-control--disabled': this.isDisabled,
        'form-select': true,
      };
    },
    isDisabled() {
      return this.options && Object.keys(this.options).length === 0;
    },
    getFieldProperties() {
      return {
        name: this.name,
        class: 'form-control__field',
        disabled: this.isDisabled,
        required: this.required,
        value: this.value,
        id: this.id,
      };
    },
  },
  methods: {
    selectUsingEnterKey(ev) {
      ev.target.blur();
    },
    selectOnFocus(){
      bus.$emit('closeAllDropdown', this.$el);
      this.expanded = true;
    },
    selectOnBlur(){
      this.onBlur();
      this.expanded = false;
    },
    updateValue(value) {
      this.$emit('change', value);
    },
    setValueAndClose(value){
      this.updateValue(value);
      this.internalModel = value;
      this.expanded = false;
    },
    openDropdown() {
      bus.$emit('closeAllDropdown', this.$el);
      this.expanded = !this.expanded;
    },
    justCloseThis(payload) {
      if(this.$el, payload, this.$el !== payload){
        this.expanded = false;
      }
    }
  },
  created () {
    bus.$on('closeAllDropdown', this.justCloseThis);
  },
  mounted () {
    // if there is matched value, use as default
    let PersonaTitle = this.$cookies.get('PersonaTitle');
    Object.keys(this.options).forEach((key) => {
      const title = this.options[key];
      if(title===PersonaTitle){
        this.internalModel = key;
        this.$emit('change', key);
      }
    });
  }
};
</script>

<style lang="scss" scoped>
  // @import "../../scss/abstracts/variables";

  label{
    &.name {
      font-family: "Untitled Sans Medium", Arial, sans-serif;
    }
  }
  ul{
    &.form-errors {
      padding: 0 !important;
      list-style: none;
    }
  }


</style>
